export default function declensionWord(num, word0, word1, word2) {
  const count = num % 10;
  if (count === 0) {
    return word0;
  } else if (count === 1) {
    return word1;
  } else if (count > 1 && count < 5) {
    return word2;
  } else {
    return word0;
  }
}
